/**
 * Redux Store Hooks
 *
 * Typed hooks for accessing Redux store in kiosk portal
 */

import { useDispatch as useReduxDispatch, useSelector as useReduxSelector } from '@ufc/core'
import type { RootState, AppDispatch } from './index'

// Typed hooks
export const useAppDispatch = () => useReduxDispatch<AppDispatch>()
export const useAppSelector = useReduxSelector.withTypes<RootState>()
